import barba from '@barba/core';
import barbaCss from '@barba/css';

export default function (routes) {
  barba.use(barbaCss);

  barba.init({
    debug: false,
    sync: true,
    prevent: function (el) {
      //prevent from running on admin links
      if (el.href.indexOf('/wp-admin/') !== -1 || el.href.indexOf('/wp-login.php') !== -1) {
        return true;
      }
    },
  });

  //global hooks
  barba.hooks.leave(() => {
    // let mobileMenu = document.querySelector('.js-mobile-menu');
    // // https://getbootstrap.com/docs/4.0/components/collapse/#via-javascript
    // // Collapse the mobile nav using Bootstrap method.
    // // Remove .show class from hamburger icon if available.
    // if(mobileMenu.classList.contains('show')) {
    //     // mobileMenu.classList.remove('show');
    //     $('#navbarCollapse').collapse('hide');
    // }

    // Destroy all waypoint animations on page
    window.Waypoint.destroyAll();
  });

  barba.hooks.enter((data) => {
    // Let's go back to the top of the page for Barba.
    window.scrollTo(0,0);

    // Assign wordpress active classes to menu links
    let menuItems = document.querySelectorAll('#menu-main-menu li a');
    menuItems.forEach(function(element) {
      if (element.pathname === data.next.url.path) {
        element.parentNode.classList.add('current-menu-item', 'current_page_item');
      } else {
        element.parentNode.classList.remove('current-menu-item', 'current_page_item');
      }
    });

    //load sage route based scripts
    routes.loadEvents();

    //register new page view in GTM
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'GTM-KKML4CN', {'page_path': location.pathname});
    }

    window.Waypoint.refreshAll();
  });

  barba.hooks.afterEnter(() => {
    // Barba brought me here.
    // Since the toolbar is outside the barba wrapper, it doesn't know the current page we're on.
    // Set the "Edit Page" Wordpress link.
    if(document.querySelector('#wp-admin-bar-edit')) {
      const editPage = document.querySelector('#wp-admin-bar-edit').firstChild;

      // Set the current Post ID
      const pageID = document.querySelector('.js-data-wrapper').dataset.post;

      // Create the current page link to edit.
      const newEditPage = window.location.origin + '/wp-admin/post.php?post=' + pageID + '&action=edit';

      // Set the new link, all is well.
      editPage.setAttribute('href', newEditPage);
    }

    window.Waypoint.refreshAll();
  });

}



// WEBPACK FOOTER //
// ./scripts/barbaInit.js